import { useTranslation } from "react-i18next";
import KiloNewtonDividedByMillimetreSquared from "../../../../../../components/Math/Units/Metric/KiloNewtonDividedByMillimetreSquared";
import { NumberFormatText } from "../../../../../../components/NumberFormatText";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";

function Bettungsziffer({ bettungsziffer }) {
  const { t } = useTranslation("translation");
  const c_Formula = `\\displaystyle c = \\frac{q_{y}}{w_{y}}`;

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.Verification.beddingFactor")}</p>}
      indicesValue={<span>c</span>}
      formulaValue={<ToolTip id={"c_Formula"} type={IconType.FORMULA} formula={c_Formula} />}
      inputValue={
        <span className="input">
          <NumberFormatText value={bettungsziffer} decimalScale={4} />
        </span>
      }
      unitValue={<KiloNewtonDividedByMillimetreSquared />}
    />
  );
}

export default Bettungsziffer;
